import { Spin } from "@dreambigger/design-system";

const Loading = ({
  spinClassName,
  fullscreen,
  size = "default",
}: {
  spinClassName?: string;
  fullscreen?: boolean;
  size?: "small" | "default" | "large";
}) => {
  return (
    <div
      className={`flex justify-center items-center w-100 ${
        fullscreen && `h-100vh`
      }`}
    >
      <Spin className={spinClassName} size={size} />
    </div>
  );
};

export default Loading;